/**
 * Wire-shape for a thread-level satisfaction score row.
 *
 * Narrower than `DbEntity.SatisfactionScore` — drops the internal
 * `organizationId`, `agentId`, `deploymentId`, `messageId` columns the
 * operator-facing detail pane never renders. The pane needs framework
 * + source + score + reasoning + recorded-at to surface the AI's
 * evaluation; keeping the row narrow avoids leaking analytics
 * denormalization fields into a UI surface that has no use for them.
 *
 * `rawScore` is the framework-aware integer. `score` is the legacy
 * float kept for compatibility with pre-framework readers and for
 * any display that wants the raw float precision (notably
 * AI_PASSIVE, whose underlying signal is a 0-1 confidence rounded
 * into `rawScore`).
 */

import { z } from "zod";

import { DbEnum } from "../../../generated/prisma-enums";

export const ThreadSatisfactionSchema = z.object({
  id: z.string().uuid(),
  framework: z.nativeEnum(DbEnum.SatisfactionFramework),
  source: z.nativeEnum(DbEnum.SatisfactionSource),
  rawScore: z.number().int(),
  score: z.number(),
  reasoning: z.string().nullable(),
  comment: z.string().nullable(),
  createdAt: z.string().datetime()
});

export type ThreadSatisfaction = z.infer<typeof ThreadSatisfactionSchema>;
